/** Stages of a new pipeline (translation keys under crm.operations.pipelines.default_stages). */
export const DEFAULT_STAGE_KEYS = [
  "new_lead",
  "contacted",
  "proposal",
  "negotiation",
  "closed",
] as const;
